import { useState } from "react";

export default function PDPGallery({ piece }) {
  const [active, setActive] = useState(0);
  const [zoom, setZoom] = useState(null);
  const images = piece.images || [];
  const src = images[active];

  const onMove = (e) => {
    const b = e.currentTarget.getBoundingClientRect();
    setZoom({ x: ((e.clientX - b.left) / b.width) * 100, y: ((e.clientY - b.top) / b.height) * 100 });
  };

  return (
    <div data-testid="pdp-gallery">
      <div
        className="relative aspect-[4/5] overflow-hidden border border-[var(--pd-border)] bg-[#050505] cursor-zoom-in"
        onMouseMove={onMove}
        onMouseLeave={() => setZoom(null)}
        data-testid="pdp-main-image-frame"
      >
        {src && (
          <img
            key={src}
            src={src}
            alt={`${piece.name} — view ${active + 1}, concept imagery`}
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 ease-out animate-[pd-fade-in_0.8s_ease]"
            style={zoom ? { transform: "scale(2.2)", transformOrigin: `${zoom.x}% ${zoom.y}%` } : undefined}
            data-testid="pdp-main-image"
          />
        )}
        {piece.concept_imagery && (
          <span className="absolute top-4 left-4 text-[0.55rem] uppercase tracking-[0.42em] text-white/60 bg-black/60 backdrop-blur px-3 py-1.5">
            Concept Imagery
          </span>
        )}
        <span className="absolute bottom-4 right-4 text-[0.55rem] uppercase tracking-[0.42em] text-white/50">
          Hover to examine
        </span>
      </div>
      <div className="mt-4 grid grid-cols-4 gap-3">
        {images.map((img, i) => (
          <button
            key={img + i}
            onClick={() => setActive(i)}
            data-testid={`pdp-thumb-${i}`}
            className={`relative aspect-square overflow-hidden border transition-colors duration-500 ${
              i === active ? "border-[var(--pd-gold)]" : "border-white/10 hover:border-white/40"
            }`}
          >
            <img src={img} alt="" className="w-full h-full object-cover" loading="lazy" />
          </button>
        ))}
      </div>
    </div>
  );
}
